import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {injectIntl} from "react-intl";
import Moment from "moment";

const Container = styled.div`
    display: flex;
    gap: 8px;
`;

const DayButton = styled.button`
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s, opacity 0.3s;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};

    background-color: ${({ selected, theme }) =>
            selected
                    ? theme.colors.primaryColor
                    : `${theme.colors.primaryColor}4D`}; /* 4D = ~0.3 opacity */

    color: ${({ selected, theme }) =>
            selected ? theme.colors.primaryText : theme.colors.primaryColor};

    border: none;
`;

class DaysOfWeekSelector extends PureComponent {
    handleToggle = index => {
        const updated = [...this.props.selectedDays];
        updated[index] = !updated[index];
        this.props.onChange(updated);
    };

    render() {
        const {days} = this.props;
        const weekDays = Moment.weekdaysShort()

        return (
            <Container>
                {days.map((enabled, i) => (
                    <DayButton
                        key={i}
                        disabled={!enabled}
                        selected={this.props.selectedDays[i]}
                        onClick={() => this.handleToggle(i)}
                    >
                        {weekDays[i]}
                    </DayButton>
                ))}
            </Container>
        );
    }
}

export default injectIntl(DaysOfWeekSelector, {withRef: true});
